import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, Routes } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectRouteService {

  private projectSubject = new BehaviorSubject<string>('');

  constructor(private currentRoute: ActivatedRoute, private router: Router) { 
    const routes: Routes = this.router.config;
    routes.forEach(route => {
      if (route.path === 'projects/Queen-Idia' || route.path === 'projects/Elites-Residence') {
        this.projectSubject.next(route.path);
      }
    });
  }

  getProjectName() {
    return this.projectSubject.asObservable();
  }
}
